import FeaturedIconBlack from '../../assets/FeaturedIconBlack.svg'
import FeaturedIconBlue from '../../assets/FeaturedIconBlue.svg'
import PriceIconBlack from '../../assets/PriceIconBlack.svg'
import PriceIconBlue from '../../assets/PriceIconBlue.svg'
import NewerIconBlack from '../../assets/NewerIconBlack.svg'
import NewerIconBlue from '../../assets/NewerIconBlue.svg'
import icons from '../../assets/BuildIcons/Icons'
import { t } from 'i18next'

const localhost = window.location.hostname === 'localhost'

const OptionIcon = (item: any) => {
  if (item.label === t('popular')) {
    return (
      <span className="featuredIcon">
        {item.isRefined ? (
          <img
            alt="featuredIconBlue"
            src={localhost ? FeaturedIconBlue : icons.featuredIconBlue}
          />
        ) : (
          <img
            alt="featuredIconBlack"
            src={localhost ? FeaturedIconBlack : icons.featuredIconBlack}
          />
        )}
      </span>
    )
  } else if (item.label === t('price_low_to_high')) {
    return item.isRefined ? (
      <span className="priceIcon">
        <img
          src={localhost ? PriceIconBlue : icons.priceIconBlue}
          alt="priceIconBlue"
        />
      </span>
    ) : (
      <span className="priceIcon">
        <img
          src={localhost ? PriceIconBlack : icons.priceIconBlack}
          alt="priceIconBlack"
        />
      </span>
    )
  } else if (item.label === t('price_high_to_low')) {
    return item.isRefined ? (
      <span className="priceIcon">
        <img
          src={localhost ? PriceIconBlue : icons.priceIconBlue}
          alt="priceIconBlue"
        />
      </span>
    ) : (
      <span className="priceIcon">
        <img
          src={localhost ? PriceIconBlack : icons.priceIconBlack}
          alt="priceIconBlack"
        />
      </span>
    )
  } else if (item.label === t('newer')) {
    return item.isRefined ? (
      <span className="newerIcon">
        <img
          src={localhost ? NewerIconBlue : icons.newerIconBlue}
          alt="newerIconBlue"
        />
      </span>
    ) : (
      <span className="newerIcon">
        <img
          src={localhost ? NewerIconBlack : icons.newerIconBlack}
          alt="newerIconBlack"
        />
      </span>
    )
  }
}

export default OptionIcon
